import {createSelector} from "reselect";
import Helpers from "./helperFunctions";
import _ from "lodash";
import Config from "../config/main";
import cookie from 'react-cookie';

export const GetSwarmData = state => state.swarmData.data;

export const CreateComponentSwarmDataSelector = dataKeySelector => createSelector([GetSwarmData, dataKeySelector], (data, key) => {
    let ret = _.cloneDeep(data);
    ret[key] && (ret[key].__swarmDataKey = key);
    return ret[key];
});

export const GetProfile = state => state.swarmData && state.swarmData.data && state.swarmData.data.profile && state.swarmData.data.profile.profile && Helpers.firstElement(state.swarmData.data.profile.profile);

export const GetBalance = createSelector(GetProfile, profile => profile && profile.balance);

export const GetTerminalBalance = state => {
    const swarmBalances = state.swarmData.data.terminal_balance?.terminals;
    const balanceObj = swarmBalances && Helpers.firstElement(swarmBalances);
    const terminalBalance = balanceObj?.balance;

    return terminalBalance;
};

export const GetToken = state => state.terminal.authData.token;

export const GetUserCurrencyId = createSelector(GetProfile, profile => profile && profile.currency_id);

export const GetLoginState = state => !!(state.user && state.user.loggedIn);

export const GetCompetitionsDataSelector = (key) => {
    return createSelector(
        [
            state => GetSwarmData(state)[key] && Helpers.firstElement((GetSwarmData(state)[key] || {}).sport),
            state => GetSwarmData(state)[key] && (Helpers.firstElement((GetSwarmData(state)[key] || {}).sport) || {}).region
        ],
        (sport, region) => {
            let retData = {
                ...sport,
                region: region && Helpers.objectToArray(region).sort(Helpers.byOrderSortingFunc),
                totalGames: 0
            };
            retData.region = region && retData.region.map((region) => {
                region._totalGames = 0;
                region.competition = Helpers.objectToArray(region.competition, null,
                    ({game}) => {
                        retData.totalGames += game;
                        region._totalGames += game;
                    }).sort(Helpers.byOrderSortingFunc);
                return region;
            });
            return retData;
        }
    );
};

export const GetPopupsData = pathname => {
    return createSelector(
        [
            state => state.uiState.popup,
            state => state.uiState.popupParams,
            state => state.cmsData.loaded.popups,
            state => state.cmsData.data.popups,
            state => state.user,
            state => state.preferences,
            state => state.uiState.tickets
        ],
        (popup, popupParams, externalPopupsLoaded, externalPopups, user, preferences, tickets) => {
            let loadedPopups = externalPopups ? externalPopups.popups : [],
                shouldOpen,
                expiryTime,
                registrationPopup = popup === "confirm" && popupParams && popupParams.data && popupParams.data.slug === 'registration-popup';

            if (loadedPopups && loadedPopups.length && !popup) {
                let routeType = Helpers.getRouteType(pathname);

                for (let i = loadedPopups.length - 1; i >= 0; i--) {

                    let popup = loadedPopups[i],
                        loginStatus = parseInt(popup.login || 0),
                        userTime = Date.now(),
                        repeatType,
                        customRepeat,
                        lastShow;

                    if (registrationPopup === (popup.slug === 'registration-popup') && popup.show_on_page === routeType &&
                        ((loginStatus === 0 && !Config.env.authorized) || (loginStatus === 1 && (Config.env.authorized || user.loginInProgress || user.reallyLoggedIn)) || loginStatus === 2)
                    ) {
                        repeatType = popup.repeat_type || (popup.custom_fields && popup.custom_fields.repeat_type);
                        customRepeat = popup.custom_repeat || (popup.custom_fields && popup.custom_fields.custom_repeat);
                        lastShow = parseInt(((cookie.load('popup' + (popup.id || '')) || {}).showedTime), 10);
                        expiryTime = 1;

                        switch (repeatType) {
                            case 'never':
                                expiryTime = false;
                                break;
                            case 'once_a_day':
                                expiryTime = 86400000;
                                break;
                            case 'once_a_week':
                                expiryTime = 604800000;
                                break;
                            case 'once_a_month':
                                expiryTime = 2592000000;
                                break;
                            case 'custom':
                                expiryTime = parseInt(customRepeat, 10) * 60;
                                break;
                        }

                        if (!(lastShow && expiryTime === false) && (!lastShow || userTime > lastShow + expiryTime || popup.slug === 'registration-popup')) {
                            shouldOpen = popup;
                            break;
                        }
                    }
                }
            }

            return {
                popup,
                popupParams,
                externalPopupsLoaded,
                externalPopups: loadedPopups,
                user,
                preferences,
                shouldOpen,
                expiryTime,
                tickets
            };
        }
    );
};

export const GetBetslipData = createSelector(
    [
        state => state.user,
        state => state.swarmData.data.betslip && JSON.stringify((() => {
            let bet = {};
            bet.event = {};
            Helpers.objectToArray(state.swarmData.data.betslip.game).forEach((game) => Object.keys(game.event).forEach((id) => {
                game.event[id].blocked = game.is_blocked;
                bet.event[id] = game.event[id];
            }));
            return bet;
        })()),
        state => state.swarmData.loaded.betslip,
        state => state.betslip,
        state => (state.user.profile && state.swarmConfigData.currency[state.user.profile.currency_id]) || {
            rate: 1,
            rounding: Config.main.currencyRounding
        },
        state => state.user.profile && state.swarmConfigData.partner && state.swarmConfigData.partner.min_bet_stakes && state.swarmConfigData.partner.min_bet_stakes[state.user.profile.currency_id],
        state => state.uiState,
        state => state.persistentUIState,
        state => state.preferences,
        state => state.uiState.lastRouteType,
        state => state.betslip && state.betslip.eventsLimitExceeded,
        state => state.swarmConfigData && state.swarmConfigData.partner,
        state => state.routing && state.routing.locationBeforeTransitions && state.routing.locationBeforeTransitions.pathname,
        state => state.terminal,
        state => state.swarmConfigData.partner && (() => {
            let tax = {};
            tax.taxType = state.swarmConfigData.partner.tax_type;
            tax.taxPercent = state.swarmConfigData.partner.tax_percent;
            tax.taxIntegrationType = state.swarmConfigData.partner.tax_integration_type;
            return tax;
        })(),
        GetTerminalBalance,
        state => state.terminal.loyalCard && state.terminal.loyalCard.result,
        state => state.swarmConfigData && (state.swarmConfigData.partner || {}),
        state => state.swarmConfigData?.currency,
    ],
    (
        user,
        data,
        loaded,
        betslip,
        currency,
        minBetAmount,
        ui,
        persistentUI,
        preferences,
        lastRouteType,
        eventsLimitExceeded,
        partner,
        pathname,
        terminal,
        tax,
        terminalBalance,
        loyalCard,
        partnerConfig,
        currencyConfig
    ) => {
        return {
            user,
            data: data && JSON.parse(data),
            loaded,
            betslip,
            currency,
            ui,
            persistentUI,
            minBetAmount,
            preferences,
            lastRouteType,
            eventsLimitExceeded,
            partner,
            pathname,
            terminal,
            tax,
            terminalBalance,
            loyalCard,
            partnerConfig,
            currencyConfig
        };
    }
);

export const GetRightMenuData = createSelector(
    [
        state => state.preferences,
        state => state.user,
        state => state.uiState.opened && state.uiState.opened.rightMenu,
        state => state.uiState.opened && state.uiState.opened.registrationForm,
        state => state.cmsData.data["help-root-" + state.preferences.lang],
        state => state.routing && state.routing.locationBeforeTransitions && state.routing.locationBeforeTransitions.pathname,
        state => state.asianFilters && state.asianFilters.opened,
        state => state.uiState.opened && state.uiState.opened.tournamentFilter
    ],
    (preferences, user, menuOpened, registrationForm, cmsData, pathname, filtersOpened, tournamentFilterOpened) => {
        let cmsPageData = _.cloneDeep(cmsData || {});
        cmsPageData.page && checkForContent(cmsPageData.page);

        return {
            preferences,
            user,
            menuOpened,
            registrationForm,
            cmsData: cmsPageData,
            pathname,
            filtersOpened,
            tournamentFilterOpened
        };
    }
);

export const GetUser = state => state.user;
export const GetCurrencyConfig = state => (state.user.profile && state.swarmConfigData.currency[state.user.profile.currency_id]) || {
    rate: 1,
    rounding: Config.main.currencyRounding
};

export const GetNewsPageData = createSelector(
    [
        state => state.preferences,
        state => state.cmsData
    ],
    (preferences, cmsData) => {
        let cmsNewsData = _.cloneDeep(cmsData || {});

        return {
            preferences,
            cmsData: cmsNewsData
        };
    }
);

export const GetLeftMenuData = () => createSelector(
    [
        state => state.swarmData.data && state.swarmData.data.leftMenuSportsList && JSON.stringify(state.swarmData.data.leftMenuSportsList),
        state => state.swarmData.loaded.leftMenuSportsList,
        state => state.swarmConfigData && state.swarmConfigData.cloudAvailable
    ],
    (data, loaded, cloudAvailable) => {
        let parsedData = data && JSON.parse(data);
        return {
            data: parsedData && Helpers.objectToArray(parsedData.sport || {}).sort(Helpers.byOrderSortingFunc),
            loaded,
            cloudAvailable
        };
    }
);

export const GetSportListDataSelector = (key) => {
    return createSelector(
        [
            state => (GetSwarmData(state)[key] || {}).sport
        ],
        (sport) => {
            return Helpers.objectToArray(sport).sort(Helpers.byOrderSortingFunc);
        }
    );
};

export const GetRegionDataSelector = (key, regionId, sportAlias) => {
    return createSelector(
        [
            state => (Helpers.firstElement((GetSwarmData(state)[key] || {}).sport) || {}).region,
            state => state.favorites,
            state => state.persistentUIState.expanded
        ],
        (regions, favorites, expanded) => {
            return {
                region: regions[regionId],
                favorites,
                expanded: expanded[sportAlias + regions[regionId].alias]
            };
        }
    );
};

export const GetSearchBarData = createSelector(
    [
        state => state.swarmData.loaded.searchResults,
        state => state.swarmData.data.searchResults,
        state => state.swarmData.loaded.casinoSearchResults,
        state => state.swarmData.data.casinoSearchResults
    ],
    (searchResults, searchResultsData, casinoSearchResults, casinoSearchResultsData) => {
        return {
            loaded: {
                casinoSearchResults,
                searchResults
            },
            data: {
                searchResults: searchResultsData,
                casinoSearchResults: casinoSearchResultsData
            }
        };
    }
);
export const GetPaymentsData = createSelector(
    [
        state => state.payments,
        state => state.user.profile ? state.user.profile.currency_name : null,
        state => state.user.profile ? state.user.profile.country_code : null,
        state => state.routing.locationBeforeTransitions.pathname.indexOf("deposit") !== -1 ? "deposit" : "withdraw"
    ],
    (payments, currencyName, countryCode, transactionType) => {
        if (!currencyName || (!Config.main.showAllAvailablePaymentSystems && !payments.filters.loaded)) {
            let {data, availableMethods, filters} = payments;
            return {
                data,
                availableMethods,
                filters
            };
        }
        let paymentsObj = Config.main.payments,
            swarmPaymentFilterEnabled = !Config.main.showAllAvailablePaymentSystems,
            loadedFilters = payments.filters.data[transactionType],
            enabledKey = `can${transactionType.charAt(0).toUpperCase()}${transactionType.slice(1)}`,
            availableMethods = paymentsObj.filter(function (method) {
                if (method.info && method.info.hasOwnProperty(currencyName) && (typeof method.info[currencyName] === "object")) {
                    if ((method.countryAllow || method.countryRestrict) && countryCode) {
                        let defaultFiltered = method[enabledKey]
                            ? method.countryAllow
                                ? method.countryAllow.indexOf(countryCode) !== -1
                                : method.countryRestrict.indexOf(countryCode) === -1
                            : false;

                        return !swarmPaymentFilterEnabled
                            ? defaultFiltered
                            : defaultFiltered && (loadedFilters.includes(method.name) || (Config.main.additionalPayments && Config.main.additionalPayments.reduce((matched, additionalMethod) => {
                                !matched && (matched = (additionalMethod.name === method.name));
                                return matched;
                            }, false)));
                    }

                    return !swarmPaymentFilterEnabled
                        ? method[enabledKey]
                        : method[enabledKey] && (
                            loadedFilters.includes(method.name) || (Config.main.additionalPayments && Config.main.additionalPayments.reduce((matched, additionalMethod) => {
                                !matched && (matched = (additionalMethod.name === method.name));
                                return matched;
                            }, false))
                        );
                }
            }).map((method) => {
                let exist,
                    amountField = {
                        name: "amount",
                        type: "number",
                        label: "Amount",
                        required: true
                    };

                if (!(method.hasBetShops || method.hideDepositButton || method.depositPrefilledAmount || method.onlyInfoTextOnDeposit)) {
                    if (method.depositFormFields) {
                        method.depositFormFields.forEach((field) => {
                            if (field.name === "amount") {
                                exist = true;
                            }
                        });

                        !exist && method.depositFormFields.push(amountField);
                    } else {
                        method.depositFormFields = [amountField];
                    }
                    exist = false;
                }

                if (method.withdrawFormFields) {
                    method.withdrawFormFields.forEach((field) => {
                        if (field.name === "amount") {
                            exist = true;
                        }
                    });
                    !exist && method.withdrawFormFields.push(amountField);
                } else {
                    method.withdrawFormFields = [amountField];
                }
                return method;
            }).sort((a, b) => {
                return a.order - b.order;
            });

        return {
            ...payments,
            availableMethods
        };
    }
);

export const getBetHistoryBetIdsList = createSelector(
    [
        state => state.routing.locationBeforeTransitions.pathname.indexOf('open-bets') !== -1 ? 'betHistory_unsettled' : 'betHistory_settled',
        state => state.swarmData
    ],
    (key, swarmData) => {
        let data = swarmData.data, betsList = data[key] && data[key].bets && data[key].bets.map(b => b.id),
            cashOutAbleBetIds = [];

        betsList && (cashOutAbleBetIds = data[key].bets.filter((b) => b.hasOwnProperty('cash_out')).reduce((events, bet) => {
            let eventIds = bet.events.map(evt => evt.selection_id);
            events = events.concat(eventIds);
            bet.eventIds = eventIds;
            return events;
        }, []));

        return {
            betsList: betsList || [],
            cashOutAbleBetIds
        };
    }
);

export const GetBetHistoryDataSelector = createSelector([
    getBetHistoryBetIdsList,
    state => state.swarmData.loaded[state.routing.locationBeforeTransitions.pathname.indexOf('open-bets') !== -1 ? 'betHistory_unsettled' : 'betHistory_settled'],
    state => state.preferences,
    state => state.user,
    state => state.swarmData.data.cashOut,
    state => state.swarmData.data[state.routing.locationBeforeTransitions.pathname.indexOf('open-bets') !== -1 ? 'betHistory_unsettled' : 'betHistory_settled'],
    state => state.betHistoryFilters,
    state => state.routing.locationBeforeTransitions.pathname
], (bets, loaded, preferences, user, cashoutData, unsettledBets, filters, pathName) => {
    return {
        swarmData: {
            bets: bets.betsList,
            loaded
        },
        cashOutAbleBetIds: bets.cashOutAbleBetIds,
        preferences,
        user,
        cashoutData,
        unsettledBets,
        filters,
        pathName
    };
});

export const betHistoryItemSelector = createSelector(
    [
        (state, props) => state.swarmData.data[props.dataSelectorKey] && state.swarmData.data[props.dataSelectorKey][props.index],
        state => state.preferences,
        state => state.swarmData && state.swarmData.data && state.swarmData.data.cashOut,
        state => state.user && state.user.profile && state.user.profile.currency_name
    ],
    (bet, preferences, cashOut, currencyName) => {
        return {
            bet,
            preferences,
            cashOut,
            currencyName
        };
    }
);

export const GetOddsFormat = state => state.uiState.oddsFormat;

export const GetLoyaltyLevels = state => state.swarmData.data.loyalty_levels &&
state.swarmData.data.loyalty_levels.details &&
state.swarmData.data.loyalty_levels.details.sort((a, b) => (a.Id - b.Id));

export const GetLoyaltyRates = state => state.swarmData.data.loyalty_rates &&
state.swarmData.data.loyalty_rates.details &&
state.swarmData.data.loyalty_rates.details.reduce((acc, curr) => {
    acc[curr.CurrencyId] = curr;
    return acc;
}, {});

export const GetWithdrawsData = createSelector(
    [
        state => state.payments.withdrawals
    ],
    (withdrawals) => ({withdrawals})
);

export const _GetFreeQuizData = createSelector(
    [
        state => state.freeQuiz,
        state => state.user.reallyLoggedIn
    ],
    (freeQuiz, loggedIn) => {
        let {data, selected, day, loadedState} = Helpers.cloneDeep(freeQuiz), filtersData = [];
        let {loading, loaded, failed} = (loadedState[day] || {});
        if (loaded && data[day] && data[day].victorinas) {
            data[day].victorinas = Object.keys(data[day].victorinas);
        }
        loggedIn && data && Object.keys(data).map((index) => {
            if (loaded && data[index] && data[index].victorinas) {
                filtersData.push({day: index, text: moment().subtract(index, 'days').format(Config.main.dateFormat)});
            }
        });

        return {
            loading,
            loaded,
            failed,
            data: data[day],
            selected,
            day,
            filtersData
        };
    }
);

export const MakeQuizListItemSelector = (quizId) => {
    return createSelector(
        [
            state => state.freeQuiz.data[state.freeQuiz.day] && state.freeQuiz.data[state.freeQuiz.day].victorinas[quizId]
        ],
        (data) => {
            if (data) {
                return Helpers.objectToArray(data, "gameId").sort(Helpers.byOrderSortingFunc);
            }
            return [];
        }
    );
};